import { newSpecPage } from '@stencil/core/testing';
import { LabDsAvatar } from './lab-ds-avatar';

describe('v4-avatar', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [LabDsAvatar],
      html: `<lab-ds-avatar size="small" />`,
    });
    expect(page.root).toEqualHtml(`
    <lab-ds-avatar size="small">
    <mock:shadow-root>
        <div>
            <div class="avatar small undefined">
                <lab-ds-icon-not-selectable size="small" icon="person"/>
            </div>
        </div>
    </mock:shadow-root>
    </lab-ds-avatar>
  `);
  });
});
